import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 17"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 1.43a6.667 6.667 0 0 0-6.667 6.667v6c0 .368.299.667.667.667h6A6.667 6.667 0 0 0 8 1.43M4.667 6.764c0-.368.298-.667.666-.667h5.334a.667.667 0 1 1 0 1.333H5.333a.667.667 0 0 1-.666-.666m0 2.666c0-.368.298-.666.666-.666h4a.667.667 0 0 1 0 1.333h-4a.667.667 0 0 1-.666-.667",
      clipRule: "evenodd"
    }
  )
);
var SvgSmsMessageLineLeftOutline = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SmsMessageLineLeftOutline_default = SvgSmsMessageLineLeftOutline;

export { SmsMessageLineLeftOutline_default as default };
